import React, { useRef, useState } from "react";
import { SpeakerHigh, SpeakerSlash } from "@phosphor-icons/react";

export const ExclusivasVideo = () => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    const v = ref.current;
    v.muted = !muted;
    if (muted) { v.currentTime = 0; v.play().catch(() => {}); }
    setMuted(!muted);
  };

  return (
    <section className="bg-[#0b0707] py-12 md:py-16" data-testid="exclusivas-video-section">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="text-center mb-6 md:mb-8">
          <div className="overline text-[#C9A24B] mb-2">Exclusivas de Ciudad Garaje</div>
          <h2 className="font-display text-4xl md:text-6xl leading-none text-white">
            <span className="text-[#E0574C]">Némesis</span> &amp; <span className="text-[#E8C979]">Ramona</span>
          </h2>
          <p className="text-gray-400 text-sm md:text-base mt-3">Sensacionales y únicas en su estilo en Venezuela.</p>
        </div>
        <div className="relative aspect-video border border-white/10 shadow-2xl shadow-black/70 overflow-hidden">
          <video
            ref={ref}
            src="/nemesis-ramona.mp4"
            poster="/nemesis-ramona-poster.jpg"
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover"
            data-testid="exclusivas-video"
          />
          <button
            onClick={toggleSound}
            className="absolute bottom-2 right-2 md:bottom-4 md:right-4 h-8 md:h-10 px-2 md:px-3 flex items-center gap-2 bg-black/70 border border-white/20 text-white text-[11px] uppercase tracking-wider hover:bg-[#B3261E] transition-colors"
            aria-label={muted ? "Activar sonido" : "Silenciar"}
            data-testid="exclusivas-sound-toggle"
          >
            {muted ? <><SpeakerSlash size={16} weight="bold" /> <span className="hidden md:inline">Activa la música</span></> : <SpeakerHigh size={16} weight="bold" />}
          </button>
        </div>
      </div>
    </section>
  );
};
